exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* @import \"react-toolbox/lib/variables.css\"; */\r\n\r\n/* @import \"react-toolbox/lib/colors.css\"; */\r\n\r\n/* RT Appbar */\r\n\r\n/* RT Drawer */\r\n\r\n/* RT List */\r\n\r\n/* Footer */\r\n\r\n/* LAYOUT CSS */\r\n\r\n.styles--content--3UsUB4XO {\r\n  min-height: 100vh;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-orient: vertical;\r\n  -webkit-box-direction: normal;\r\n      -ms-flex-direction: column;\r\n          flex-direction: column;\r\n}\r\n\r\n.styles--content--3UsUB4XO > section {\r\n  -webkit-box-flex: 1;\r\n      -ms-flex: 1 1 auto;\r\n          flex: 1 1 auto;\r\n  padding: 24px;\r\n}\r\n\r\n.styles--content--3UsUB4XO > footer {\r\n  height: 10rem;\r\n}\r\n\r\n/*\r\n.navDrawerDrawer {\r\n  background-color: var(--palette-grey-800) !important;\r\n  border: none !important;\r\n}\r\n*/\r\n", ""]);

// exports
exports.locals = {
	"content": "styles--content--3UsUB4XO"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[name]--[local]--[hash:base64:8]"}!./node_modules/postcss-loader/lib!./src/views/App/styles.css
// module id = 1050
// module chunks = 1